import { isAdmin } from "./helpers";
const PlanPermissions = {
    plans: {
        index: ({ user }) => isAdmin(user),
    },
};
export default PlanPermissions;
